import React from 'react';

import { Form, Popover } from 'antd';
import {
  Button,
  Column,
  Input,
  Row,
  Text,
  Notification,
  LoadingOutlined,
  Space,
  EditOutlined,
} from 'farmhub-ui-core';
import styled from 'styled-components';

import { useAppDispatch, useAppSelector } from 'app';
import { updatePartner, updatePartnerCode } from 'slice';
import { theme } from 'styled';
import {
  checkFirstCharIsNotSpace,
  checkOnlySpaces,
  updateAttrElement,
} from 'utils';

type UpdateCodeFormProps = {
  form: any;
  prevCode: string | undefined;
  onUpdatePrevCode: (val: string | undefined) => void;
};

const UpdateCodeFormModal = ({
  form,
  prevCode,
  onUpdatePrevCode,
}: UpdateCodeFormProps): JSX.Element => {
  const dispatch = useAppDispatch();
  const modal = useAppSelector(state => state.modal);
  const [isSubmit, setIsSubmit] = React.useState(false);
  const [isVisible, setIsVisible] = React.useState(false);

  const handleSubmit = async (val: any) => {
    try {
      const res: any = await dispatch(
        updatePartner({
          id: modal?.dataPartnerNoteModal?.id || '',
          body: { code: val },
        })
      ).unwrap();

      const { data } = res;

      if (data?.code) {
        form.setFieldsValue({ code: data.code || '' });
        onUpdatePrevCode(data.code);
        updateAttrElement(
          `${modal?.dataPartnerNoteModal?.id}-code`,
          'innerHTML',
          data.code.length > 9 ? `${data.code.slice(0, 6)}...` : data.code
        );
        updateAttrElement(
          `${modal?.dataPartnerNoteModal?.id}-code-tooltip`,
          'innerHTML',
          data.code
        );

        dispatch(updatePartnerCode({ code: data.code }));
      }
    } catch (error: any) {
      Notification('error', 'Cập nhật SKU đối tác thất bại', error);
      form.setFieldsValue({ code: prevCode });
    }
  };

  const handleSubmitForm = () => {
    form.validateFields().then(async (values: any) => {
      if (values.code != prevCode) {
        try {
          setIsSubmit(true);
          await handleSubmit(values.code);
          setIsVisible(false);
        } catch (e) {
          console.log(e);
        } finally {
          setIsSubmit(false);
        }
      }
    });
  };

  return (
    <>
      <Popover
        content={
          <UpdateCodeFormWrapper>
            <Form form={form}>
              <Column>
                <Text>Mã đối tác:</Text>
                <Space height={6} />
                <Row alignItems="flex-start" styles={{ gap: 12 }}>
                  <Form.Item
                    name="code"
                    rules={[
                      {
                        required: true,
                        message: 'Bạn chưa nhập SKU đối tác!',
                      },
                      ({ getFieldValue }) => {
                        return {
                          validator(_, value) {
                            if (value && value.length > 10) {
                              return Promise.reject('SKU không quá 10 ký tự!');
                            }

                            if (
                              value &&
                              value.length > 0 &&
                              checkOnlySpaces(value)
                            ) {
                              return Promise.reject(
                                'SKU đối tác không dùng chuỗi rỗng!'
                              );
                            }

                            if (
                              value &&
                              value.length > 0 &&
                              checkFirstCharIsNotSpace(value)
                            ) {
                              return Promise.reject(
                                'SKU đối tác không được bắt đầu là khoảng trắng!'
                              );
                            }

                            return Promise.resolve();
                          },
                        };
                      },
                    ]}
                    style={{ width: '100%' }}
                  >
                    <Input
                      height={theme.input.height.md}
                      maxLength={10}
                      placeholder="Nhập mã code đối tác"
                    />
                  </Form.Item>
                </Row>

                <Button
                  height={theme.button.height.sm}
                  width="100%"
                  onClick={handleSubmitForm}
                >
                  {isSubmit ? (
                    <LoadingOutlined spin style={{ fontSize: 18 }} />
                  ) : (
                    'Cập nhật'
                  )}
                </Button>
              </Column>
            </Form>
          </UpdateCodeFormWrapper>
        }
        overlayClassName="popoverNoteEditor"
        placement="bottomLeft"
        style={{ width: '264px' }}
        trigger="click"
        visible={isVisible}
        onVisibleChange={setIsVisible}
      >
        <EditOutlined
          className="icon"
          style={{ fontSize: 12, color: theme.colors.text.secondary }}
          onClick={() => setIsVisible(!isVisible)}
        />
      </Popover>
    </>
  );
};

export default UpdateCodeFormModal;

export const UpdateCodeFormWrapper = styled.div`
  width: 228px;
`;
